import { useTranslation } from 'react-i18next'
import type { LifecyclePhase } from '../../types'

interface LifecycleBadgeProps {
  phase: LifecyclePhase
}

const PHASE_CONFIG: Partial<Record<LifecyclePhase, { label: string; className: string }>> = {
  new: { label: 'New', className: 'bg-gcg-tint text-neutral-800' },
  phase_out: { label: 'Phase Out', className: 'bg-amber-50 text-amber-700' },
}

export default function LifecycleBadge({ phase }: LifecycleBadgeProps) {
  const { t } = useTranslation()
  if (phase === 'active' || phase === 'unknown') return null
  // Discontinued (EOL) — localized, so it reads correctly per language (WEB-426).
  if (phase === 'obsolete') {
    return (
      <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-red-50 text-red-700">
        {t('shop.product.discontinued')}
      </span>
    )
  }
  const config = PHASE_CONFIG[phase]
  if (!config) return null
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  )
}
